import React from 'react';

export default function Footer() {
  return (
    <footer className="text-center mt-8">
      <a
        href="https://zhanto.id"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-500 hover:text-blue-400 transition-colors cursor-pointer"
      >
        ran-as-administrator
      </a>
    </footer>
  );
}
